import { Login, SensorOccupied, Work } from '@mui/icons-material'

export const tiposEntradaMap = {
  '02': SensorOccupied,
  '04': Work,
  '00EN': Login,
  DEFAULT: Login,
}

export const colorEntradaMap = {
  '02': 'warning',
  '04': 'error',
  '05': 'primary',
  '00EN': 'success',
  DEFAULT: 'success',
}
